import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface RoomAmenityFilterSelectProps {
  /** Distinct amenity names present across the location's rooms. */
  availableRoomAmenities: string[];
  /** Currently-selected amenity names (AND filter). */
  selectedRoomAmenities: string[];
  onSelectionChange: (names: string[]) => void;
  idPrefix?: string;
}

/**
 * Filter the calendar to rooms that have ALL of the ticked amenities. Deliberately has no
 * "select all" toggle — ticking every amenity would require a single room to have all of them
 * (AND semantics) and usually match nothing.
 */
export const RoomAmenityFilterSelect = ({
  availableRoomAmenities,
  selectedRoomAmenities,
  onSelectionChange,
  idPrefix = "room-amenity-filter",
}: RoomAmenityFilterSelectProps) => {
  return (
    <div className="flex flex-col gap-1 max-h-[300px] overflow-y-auto">
      {availableRoomAmenities.map((name) => (
        <div
          key={name}
          className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 rounded cursor-pointer"
        >
          <Checkbox
            id={`${idPrefix}-${name}`}
            checked={selectedRoomAmenities.includes(name)}
            onCheckedChange={(checked) => {
              if (checked) {
                onSelectionChange([...selectedRoomAmenities, name]);
              } else {
                onSelectionChange(selectedRoomAmenities.filter((n) => n !== name));
              }
            }}
          />
          <Label htmlFor={`${idPrefix}-${name}`} className="flex-1 cursor-pointer">
            {name}
          </Label>
        </div>
      ))}
    </div>
  );
};
